import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { head, pipe, sort, ascend, prop, values, omit } from "ramda";
import ButtonGroup from "@mui/material/ButtonGroup";

const getLowestCornerPosition = axis => coords =>
  pipe(
    // remove the coordinates of the rotation corner/handle
    omit(["mtr"]),
    values,
    sort(ascend(prop(axis))),
    head,
    prop(axis)
  )(coords);

const getLowestX = getLowestCornerPosition("x");
const getLowestY = getLowestCornerPosition("y");

const InlineMenu = ({ shape, children }) => {
  const menuRef = useRef(null);
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [isEditing, setIsEditing] = useState(false);

  const enableEditing = () => {
    shape.setCoords();

    const height = menuRef.current.clientHeight;

    const left = getLowestX(shape.oCoords);
    const top = getLowestY(shape.oCoords);

    setX(left);
    setY(top - height);
    setIsEditing(true);
  };
  const disableEditing = () => setIsEditing(true);

  useEffect(() => {
    shape.on("editing:entered", enableEditing);
    shape.on("editing:exited", disableEditing);

    return () => {
      shape.off("editing:entered", enableEditing);
      shape.off("editing:exited", disableEditing);
    };
  }, [shape]);

  const getButtonGroupStyle = () => ({
    backgroundColor: "white",
    position: "absolute",
    left: x,
    top: y,
    visibility: isEditing ? "visible" : "hidden",
    zIndex: 1306,
    boxShadow: "6px 6px 8px 1px rgba(0, 0, 0, 0.32)"
  });

  return (
    <ButtonGroup variant="text" style={getButtonGroupStyle()} ref={menuRef}>
      {children}
    </ButtonGroup>
  );
};

InlineMenu.propTypes = {
  shape: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element)
};

export default InlineMenu;
